export default __webpack_public_path__ + "static/media/starIcon.a2f8d8ca.svg";